import { Link } from "react-router-dom";

const AdminDashboard = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Admin Dashboard</h1>
      <p style={styles.subtitle}>Manage your store efficiently</p>

      <div style={styles.grid}>
        <div style={styles.card}>
          <h3>🛍 Products</h3>
          <p>Manage, add, and update products</p>
          <Link to="/admin/products" style={styles.link}>
            Go to Products →
          </Link>
        </div>

        <div style={styles.card}>
          <h3>📦 Orders</h3>
          <p>View and manage customer orders</p>
          <Link to="/admin/orders" style={styles.link}>
            View Orders →
          </Link>
        </div>

        <div style={styles.card}>
          <h3>⚙️ Admin</h3>
          <p>Security & session</p>
          <button
            onClick={() => {
              localStorage.removeItem("isAdmin");
              window.location.href = "/admin/login";
            }}
            style={styles.logout}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "32px",
  },
  title: {
    fontSize: "28px",
    marginBottom: "4px",
  },
  subtitle: {
    color: "#666",
    marginBottom: "30px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "20px",
  },
  card: {
    padding: "22px",
    borderRadius: "10px",
    background: "#fff",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
  },
  link: {
    display: "inline-block",
    marginTop: "12px",
    fontWeight: "600",
    color: "#111",
    textDecoration: "none",
  },
  logout: {
    marginTop: "14px",
    padding: "10px 14px",
    borderRadius: "6px",
    border: "none",
    background: "#c62828",
    color: "#fff",
    fontWeight: "600",
    cursor: "pointer",
  },
};

export default AdminDashboard;
